import React from 'react';
import {Navigate, RouteObject, useParams} from 'react-router';
import {AuthRoute} from '@common/auth/guards/auth-route';

const page = async (
  name: keyof typeof import('@app/referral/center/referral-center-pages'),
) => ({
  Component: (await import('@app/referral/center/referral-center-pages'))[name],
});

/**
 * My Score, the member's TeliHand Score panel at /my-score/*. The public
 * /score page is server-rendered; signed-in members are sent here.
 */
export const referralRoutes: RouteObject[] = [
  {
    path: 'my-score',
    element: <AuthRoute />,
    children: [
      {
        lazy: async () => ({
          Component: (await import('@app/referral/center/referral-center-layout'))
            .ReferralCenterLayout,
        }),
        children: [
          {index: true, element: <Navigate to="/my-score/dashboard" replace />},
          // The layout shows the join step to non-members on every page.
          {path: 'join', element: null},
          {path: 'dashboard', lazy: () => page('ReferralDashboardPage')},
          {path: 'links', lazy: () => page('ReferralLinksPage')},
          {
            path: 'plans',
            lazy: async () => ({
              Component: (await import('@app/referral/center/score-extras')).ScorePlansPage,
            }),
          },
          {path: 'reports', lazy: () => page('ReferralReportsPage')},
          {path: 'withdraw', lazy: () => page('ReferralWithdrawPage')},
          {path: 'payout-settings', lazy: () => page('ReferralPayoutSettingsPage')},
          {path: 'rules', lazy: () => page('ReferralRulesPage')},
        ],
      },
    ],
  },
  // Older addresses: the panel used to be the "Referral Center".
  {path: 'referral/:page', element: <OldPanelRedirect />},
  {path: 'drive/referral/*', element: <Navigate to="/my-score/dashboard" replace />},
];

function OldPanelRedirect() {
  const {page} = useParams();
  return <Navigate to={`/my-score/${page ?? 'dashboard'}`} replace />;
}
